import { TZDate } from '@date-fns/tz'
import {
  format,
  formatDistanceToNowStrict as dfsFormatDistanceToNowStrict,
  subHours,
} from 'date-fns'
import { ptBR } from 'date-fns/locale/pt-BR'

function capitalize(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

function isValidDate(date?: string) {
  if (date === '0000-00-00') return false

  return true
}

export function handleDate(date?: string) {
  if (!date) return ''

  const dateWithoutTimezone = date ? date.replace(/Z$/g, '') : ''

  return dateWithoutTimezone.indexOf('T') > -1
    ? dateWithoutTimezone
    : dateWithoutTimezone + 'T00:00:00'
}

export function formatDateToText(date?: string, locale = ptBR): string {
  if (!isValidDate(date)) return ''

  return format(
    new Date(handleDate(date) || Date.now()),
    "dd 'de' MMMM 'de' yyyy",
    {
      locale,
    }
  )
}

export function formatDateToddLLLHmm(date?: string, locale = ptBR): string {
  if (!isValidDate(date)) return ''

  return capitalize(
    format(new Date(handleDate(date) || Date.now()), 'dd LLL • HH:mm', {
      locale,
    })
  )
}

export function formatDateToddLLLyHmm(date?: string, locale = ptBR): string {
  if (!isValidDate(date)) return ''

  return capitalize(
    format(new Date(handleDate(date) || Date.now()), 'dd LLL y • HH:mm', {
      locale,
    })
  )
}

export function formatDateToMMMMyyyy(date?: string, locale = ptBR): string {
  if (!isValidDate(date)) return ''

  return capitalize(
    format(new Date(handleDate(date) || Date.now()), "MMMM 'de' yyyy", {
      locale,
    })
  )
}

// TODO: Essa função está retornando a data atual ao passar uma string vazia no input.
export function formatDateToDdMMM(date?: string, locale = ptBR): string {
  if (!isValidDate(date)) return ''

  return format(new Date(handleDate(date) || Date.now()), 'dd MMM', {
    locale,
  })
}

export function formatDateToDDMM(
  date?: string,
  separator = '/',
  locale = ptBR
): string {
  if (!isValidDate(date)) return ''

  return format(new Date(handleDate(date) || Date.now()), `dd${separator}MM`, {
    locale,
  })
}

export function formatDateToDD(date?: string, locale = ptBR): string {
  if (!isValidDate(date)) return ''

  return format(new Date(handleDate(date) || Date.now()), `dd`, {
    locale,
  })
}

export function formatDateToddMMMM(date?: string, locale = ptBR): string {
  if (!isValidDate(date)) return ''

  return format(new Date(handleDate(date) || Date.now()), "dd 'de' MMMM", {
    locale,
  })
}

export function formatDateToddMMMMyyy(date?: string, locale = ptBR): string {
  if (!isValidDate(date)) return ''

  return format(
    new Date(handleDate(date) || Date.now()),
    "dd 'de' MMMM 'de' yyy",
    {
      locale,
    }
  )
}

export function formatDateToddMMM(
  date?: string,
  separator = ' ',
  locale = ptBR
): string {
  if (!isValidDate(date)) return ''

  return format(
    new Date(handleDate(date) || Date.now()),
    `dd'${separator}'MMM`,
    {
      locale,
    }
  )
}

export function formatDate(
  date?: string,
  separator = '/',
  locale = ptBR
): string {
  if (!isValidDate(date)) return ''

  return format(
    new Date(handleDate(date) || Date.now()),
    `dd${separator}MM${separator}yyyy`,
    {
      locale,
    }
  )
}

export function formatDateMMyyyy(date?: string, locale = ptBR): string {
  if (!isValidDate(date)) return ''

  return format(new Date(handleDate(date) || Date.now()), 'MM/yyyy', {
    locale,
  })
}

export function formatDateMMyy(date?: string, locale = ptBR): string {
  if (!isValidDate(date)) return ''

  return format(new Date(handleDate(date) || Date.now()), 'MM/yy', {
    locale,
  })
}

export function formatWeekDay(date?: string, locale = ptBR) {
  if (!isValidDate(date)) return ''

  return format(new Date(handleDate(date) || Date.now()), 'EEEE', {
    locale,
  })
}

export function formatDistanceToNowStrict(date?: string): string {
  if (!isValidDate(date)) return ''

  const utcDate = subHours(new Date(handleDate(date) || Date.now()), 3)

  return dfsFormatDistanceToNowStrict(utcDate, {
    locale: ptBR,
    addSuffix: false,
  })
}

export const formatDateToLocale = (isoDate?: string, locale = ptBR) => {
  const date = new Date(isoDate ?? '')

  if (isNaN(date.getTime())) return ''

  const offset = -3 * 60
  const adjustedDate = new Date(date.getTime() + offset * 60 * 1000)
  return format(adjustedDate, 'dd MMM', {
    locale,
  })
}

export const monthFormatter = (date: string, locale = ptBR) => {
  const tzDate = new TZDate(date, 'UTC')
  const monthName = format(tzDate, 'LLLL', { locale })
  return monthName.charAt(0).toUpperCase() + monthName.slice(1)
}
